<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    progress
    :steps="steps"
    @onStepBack="stepBack"
    @close="handleClose"
  >
    <template v-slot:dialog.body>
      <slot />
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        v-if="steps.current === steps.total"
        :loading="isSaving"
        @click.native="handleSave"
      >
        Save Details
      </PrimaryButton>
      <PrimaryButton @click.native="nextStep" v-else>
        Continue
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  props: {
    dialogSettings: {
      type: Object,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    },
    isSaving: Boolean
  },
  components: { DialogFull, PrimaryButton },
  data() {
    return {
      steps: {
        current: 1,
        total: this.totalSteps
      }
    };
  },
  methods: {
    nextStep() {
      this.steps.current++;
      this.$emit("onStepsUpdate", this.steps.current);
    },
    stepBack() {
      this.steps.current--;
      this.$emit("onStepsUpdate", this.steps.current);
    },
    handleSave() {
      this.$emit("onSave");
    },
    handleClose() {
      this.$emit("onClose");
    }
  }
};
</script>
